import { request } from "@esri/arcgis-rest-request";

export const AddWwtp = async (payLoad, archive, Config) =>  {

    console.log("Payload:", JSON.stringify(payLoad));
    //let url = `${Config.server.serverUrl}/S4L_CS_Boundaries/FeatureServer/` + ( ( archive ) ? '4' : '2' ) + '/addFeatures';
    let url = `${Config.server.portalUrl}/sharing/servers/` + ((archive) ? `${Config.server.wwtpArchivePortalItem}` : `${Config.server.wwtpFeaturePortalItem}`) + '/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/' + ((archive) ? '4' : '2') + '/addFeatures';
  
    try {  
        const resp = await request(url,{
            httpMethod: 'POST',
            params: {
                token: Config.server.apiKey,
                features: payLoad,
                f: "json"
           }});
        console.log(resp);
        if (resp.addResults[0].success)
            return true;
        else
            return false;
    } catch (error) {
        console.log(error);
        return null;
    } 

}


